import styled from "styled-components";

export const DateWrapper = styled.div`
    min-width: 3.5rem;
    padding-left: 0;
    display: inline-block;
`;

export const DayWrapper = styled.div`
    min-width: 2.5rem;
    display: inline-block;
`;

export const ReasonWrapper = styled.div`
    display: inline-block;
`;

export const AbsenceWrapper = styled.div`
    padding-top: 1.243rem;
`;
